import z from 'zod'

export const GetCountByMonthSchema = z.object({
  count: z.number(),
  month: z.string(),
  month_name: z.string(),
})

export const GetSummarySchema = z.object({
  average: z.number(),
  date_from: z.coerce.date(),
  date_to: z.coerce.date(),
  total: z.number(),
})
